import React, { useState, useContext, useMemo, useEffect } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import { ProductForm } from "./ProductForm";
import { StockForm } from "./StockForm";
import { StockReport } from "./StockReport";
import { AuthContext } from "../../contexts/Auth/AuthContext";
import { staffCanAccessWalletStockSubtab } from "../../config/menuAccessCatalog";

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`stock-tabpanel-${index}`}
      aria-labelledby={`stock-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

const STOCK_TAB_DEFS = [
  { id: "config_stock_products", label: "Produtos", Component: ProductForm },
  { id: "config_stock_entry", label: "Entrada de Estoque", Component: StockForm },
  { id: "config_stock_report", label: "Relatório de Estoque", Component: StockReport },
];

export const StockTabs = () => {
  const { user } = useContext(AuthContext);

  const visibleTabs = useMemo(
    () => STOCK_TAB_DEFS.filter((t) => staffCanAccessWalletStockSubtab(user, t.id)),
    [user]
  );

  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    setActiveTab((prev) =>
      visibleTabs.length && prev >= visibleTabs.length ? 0 : prev
    );
  }, [visibleTabs.length]);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  if (!visibleTabs.length) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="text.secondary">
          Nenhuma sub-aba de Estoque disponível para seu usuário.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontSize: "14px",
              fontWeight: "600",
              minHeight: "40px",
              color: "#666",
              "&.Mui-selected": {
                color: "#1e958c",
              },
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#1e958c",
            },
          }}
        >
          {visibleTabs.map((t) => (
            <Tab key={t.id} label={t.label} />
          ))}
        </Tabs>
      </Box>

      {visibleTabs.map((t, index) => {
        const Cmp = t.Component;
        return (
          <TabPanel key={t.id} value={activeTab} index={index}>
            <Box sx={{ p: 0 }}>
              <Cmp />
            </Box>
          </TabPanel>
        );
      })}
    </Box>
  );
};
